var render, staticRenderFns
import script from "./Title.js?vue&type=script&lang=js&external"
export * from "./Title.js?vue&type=script&lang=js&external"
import style0 from "./Title.scss?vue&type=style&index=0&id=d866fdee&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d866fdee",
  null
  
)

export default component.exports